import React, { useState } from "react";
import { Roles } from "../../../constansts/LocalData";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import { ROLES } from "../../../constansts/Roles";

import { Form, FormikProvider, useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";

import { useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import { addUserAsync } from "../../../redux/features/addUserSlice";

import { useNavigate } from "react-router-dom";
import validation from "../../../helpers/validation";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import { BASE_URL } from "../../../Api/services";

export default function UserAdd() {
   const [selectedOption, setSelectedOption] = useState(null);
   const [parentId, setParentId] = useState();

   const dispatch = useDispatch();
   const navigate = useNavigate();

   // const parent_ids = useSelector((state) => state?.getParentIdAsync)
   const handleUser = async (formData) => {
      dispatch(backdropLoadingAction(true));
      const data = {
         name: formData.userName,
         mobile: formData.mobile,
         role_id: formData.userType,
         password: formData.password,
         c_password: formData.c_password,
         address: "kolkata, kolkata",
         model_id: 1,
         action_id: 1,
         parent_user_ids: [formData?.parentId],
      };

      dispatch(
         addUserAsync({
            data,
            done: () => {
               dispatch(backdropLoadingAction(false));
               navigate("/user/user-List");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const userAddSchema = yup.object().shape({
      userName: validation.name(),

      mobile: validation.mobile,

      userType: yup.string().required("Required"),
      password: yup.string().required("Password is required!"),
      c_password: yup
         .string()
         .required("Confirm password is required!")
         .oneOf([yup.ref("password"), null], "Passwords must match"),
   });

   const formik = useFormik({
      initialValues: {
         userName: "",
         mobile: "",
         userType: "",
         password: "",
         c_password: "",
         parentId: "",
      },
      validationSchema: userAddSchema,
      onSubmit: handleUser,
   });

   const { errors, touched, getFieldProps, handleSubmit, resetForm } = formik;
   const parentApiUrl = (slug) =>
      `${BASE_URL}/user/parent_user/${slug}?model_id=1&action_id=3`;

   const handleParentId = (e) => {
      if (e && e.length > 0) {
         formik.setFieldValue("userType", e[0].value);
         setSelectedOption(e[0].value);
         const slug = "manager";
         axios
            .get(parentApiUrl(slug), {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            })
            .then((response) => {
               setParentId(response.data.res);
            })
            .catch((error) => {
               console.error("API Error:", error);
            });
      } else {
         formik.setFieldValue("userType", "");
         setSelectedOption(null);
      }
   };

   return (
      <div>
         <BodyHeader title="Add User" />
         <div className="container">
            {/* <h1 className="mb-4 text-center">Add User</h1> */}
            <div className="card card-primary ">
               <div className="card-header">
                  <h3 className="card-title text-center">Add User</h3>
               </div>
               <FormikProvider value={formik}>
                  <Form className="needs-validation" noValidate>
                     <div className="card-body">
                        <div className="form-group">
                           <CustomInput
                              label="Enter Name"
                              name="userName"
                              require={true}
                              id="#userName"
                              inputType="text"
                              placeholder="Enter User Name"
                              {...getFieldProps("userName")}
                              errors={errors.userName && touched.userName}
                              message={errors.userName}
                           />
                        </div>

                        <div className="form-group">
                           <CustomInput
                              label="Enter Mobile No."
                              name="mobile"
                              id="#mobile"
                              require={true}
                              inputType="number"
                              maxLength={10}
                              placeholder="Enter Mobile No."
                              {...getFieldProps("mobile")}
                              errors={errors.mobile && touched.mobile}
                              message={errors.mobile}
                           />
                        </div>

                        <div className="form-group">
                           <CustomDropdown
                              label="User Type"
                              selected=""
                              name="userType"
                              require={true}
                              optionData={Roles}
                              {...getFieldProps("userType")}
                              onChange={(e) => handleParentId(e)}
                              errors={touched.userType && errors.userType}
                              message={errors.userType}
                           />
                        </div>

                        {(selectedOption === 2 || selectedOption === 4) && (
                           <div className="form-group">
                              <CustomDropdown
                                 label={"Management"}
                                 selected=""
                                 name="parentId"
                                 require={false}
                                 optionData={parentId?.map?.((key, index) => {
                                    return {
                                       label: key.name,
                                       value: key.id,
                                    };
                                 })}
                                 {...getFieldProps("parentId")}
                                 onChange={(e) => {
                                    formik.setFieldValue("parentId", e?.[0]?.value || "");
                                 }}
                              />
                           </div>
                        )}

                        <div className="form-group">
                           <CustomInput
                              label="Password"
                              name="password"
                              id="#password"
                              require={true}
                              inputType="password"
                              placeholder="********"
                              {...getFieldProps("password")}
                              errors={errors.password && touched.password}
                              message={errors.password}
                           />
                        </div>

                        <div className="form-group">
                           <CustomInput
                              label="Confirm Password"
                              name="c_password"
                              id="#c_password"
                              require={true}
                              inputType="password"
                              placeholder="********"
                              {...getFieldProps("c_password")}
                              errors={errors.c_password && touched.c_password}
                              message={errors.c_password}
                           />
                        </div>
                     </div>
                     <div className="card-footer d-flex justify-content-center">
                        <button
                           type="submit"
                           className="btn btn-primary"
                           onClick={handleSubmit}
                        >
                           Add User
                        </button>
                     </div>
                  </Form>
               </FormikProvider>
            </div>
         </div>
      </div>
   );
}
